import * as $ from "jquery";

export default class UploadComponent {
    constructor() {
        this.componentSelector = "#promotions-upload";
        this.instance = this;
    }

    init() {
        let instance = this;
        if ($(instance.componentSelector).length > 0) {
            instance.bind();
        }
    }

    bind() {
        let instance = this;
        $('.js-upload-promotions').off().on('click', function () {
            $('#promotions-upload').addClass('locked');
            instance.upload();
        });
    }

    upload() {
        var uploadModel = {};
        uploadModel.Files = [];

        var files = $('.dropzone .dz-filename span');
        $.each(files, function () {
            var file = {};
            file.FileName = $(this).html();
            uploadModel.Files.push(file);
        });

        axios({
            method: 'post',
            url: "/uploadexcel/save",
            data: { files: uploadModel}
        }).then(function (response) {
            $('#promotions-upload').removeClass('locked');

            if (parseInt(response.data) == 0) {
                window.location.href = "/promotions";
            }
            else {
                bootbox.alert("Importen hittade ett fel på rad " + response.data + " som gjorde att filen inte kunde läsas in.");
            }

        }).catch(function (error) {
            $('#promotions-upload').removeClass('locked');

            var message = "ProductHub är inte tillgänglig just nu. Inga kampanjer har uppdaterats.";

            if (error.response && error.response.data && error.response.data.message) {
                message = error.response.data.message;
            }

            bootbox.alert(message);
        });
    }
}